var map = {
	"./Naked cake 4 andares.webp": 1941,
	"./beatriz.webp": 51,
	"./bianca.webp": 869,
	"./caribe.png": 344,
	"./cindy.webp": 1306,
	"./clara.webp": 9018,
	"./colonial.png": 9522,
	"./delicado.png": 9865,
	"./desejos.png": 5164,
	"./dress.png": 8098,
	"./elia.png": 8687,
	"./elide.png": 87,
	"./elizabeth.png": 4792,
	"./enlace.png": 4639,
	"./espatulado.webp": 7494,
	"./eva.webp": 1020,
	"./felices.jpeg": 6990,
	"./flora.webp": 7521,
	"./florence.png": 2587,
	"./flowers.webp": 3788,
	"./frisado.webp": 9230,
	"./garden.png": 9527,
	"./golden.jpeg": 6311,
	"./infinity.png": 6833,
	"./julia.png": 4184,
	"./juliana.png": 3180,
	"./lara.webp": 8980,
	"./laura.jpeg": 4902,
	"./laços.png": 9721,
	"./livia.png": 3204,
	"./lorena.png": 5572,
	"./maya.png": 7839,
	"./mileni.webp": 7639,
	"./nakedcake.png": 7292,
	"./nanda.webp": 5931,
	"./napoles.png": 5390,
	"./neon black.png": 4572,
	"./orquídeas.png": 3718,
	"./perolas.png": 3454,
	"./prestigio.png": 9849,
	"./rebecca.png": 2282,
	"./rendas.png": 9136,
	"./ruffles.png": 1203,
	"./ruffleswithe.png": 2633,
	"./rustico.png": 5194,
	"./safira.jpeg": 3983,
	"./soli.png": 9727,
	"./sophia.webp": 4413,
	"./valsa.png": 6068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7412;